/*
 * Test Candidates sign-up source (tc-signup-source).
 *
 * Remembers how a visitor first reached www.testcandidates.com, so the sign-up
 * can say where the new organisation came from. Our own record, not Google's:
 * it is only sent to our API with a sign-up (admin SignupSource decides the
 * channel) and never shared.
 *
 * Why it may run without consent (approved 8 Oct 2026, roadmap TC fast track):
 * - UK: the PECR statistics exemption (Data (Use and Access) Act 2025,
 *   Schedule A1, in force 5 Feb 2026). First party, no identifier, sole purpose
 *   is seeing which pages lead to new accounts. Disclosed in the cookie table.
 * - Objection: nothing is stored when the browser sends Global Privacy
 *   Control or Do Not Track.
 * - EEA, Iceland, Liechtenstein, Norway, Switzerland: no exemption, so only
 *   after analytics consent. The browser cannot see the country, so a
 *   European time zone other than the UK's counts as one of these regions.
 * - Ad click ids (gclid, msclkid) are kept as a yes/no flag; the id itself
 *   only with advertising consent. At sign-up the Google click id may also come
 *   from Google's own _gcl_aw cookie (see adClick).
 *
 * Canonical copy: picked/resources/signup-source/. The splash copies it in at
 * build; the employer app imports it. ES5 only, it is served untranspiled.
 */
;(function (root) {
  var KEY = 'tc-signup-source'
  var DAYS = 30
  var UTM = ['source', 'medium', 'campaign', 'term', 'content']
  var UK_ZONES = ['Europe/London', 'Europe/Belfast', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/Isle_of_Man', 'GB']
  var EEA_ATLANTIC = ['Atlantic/Reykjavik', 'Atlantic/Canary', 'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Faroe', 'Arctic/Longyearbyen']
  var AUTH_HOSTS = ['accounts.google.com', 'login.microsoftonline.com', 'login.live.com', 'checkout.stripe.com', 'billing.stripe.com']

  function store () {
    try { return root.localStorage } catch (e) { return null }
  }

  function consent () {
    var s = store()
    var r = null
    try { r = JSON.parse(s && s.getItem('picked-consent')) } catch (e) {}
    var ts = r ? Date.parse(r.ts) : NaN
    var now = new Date().getTime()
    var usable = !!(r && r.v === 1 && !isNaN(ts) && now - ts <= 365 * 864e5 && ts - now <= 864e5)
    return { analytics: usable && r.analytics === true, advertising: usable && r.advertising === true, advertisingRefused: usable && r.advertising === false }
  }

  function objected () {
    var n = root.navigator || {}
    return n.globalPrivacyControl === true || n.doNotTrack === '1' || n.doNotTrack === 'yes' || root.doNotTrack === '1'
  }

  function needsConsent () {
    var zone = ''
    try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '' } catch (e) {}
    if (UK_ZONES.indexOf(zone) !== -1) return false
    return zone.indexOf('Europe/') === 0 || EEA_ATLANTIC.indexOf(zone) !== -1
  }

  function param (query, name) {
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(query)
    if (!m) return ''
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')) } catch (e) { return '' }
  }

  function referrerHost (doc) {
    var m = /^https?:\/\/([^\/?#:]+)/i.exec(doc.referrer || '')
    if (!m) return ''
    var host = m[1].toLowerCase()
    if (/(^|\.)testcandidates\.com$/.test(host) || host === root.location.hostname) return ''
    if (AUTH_HOSTS.indexOf(host) !== -1) return ''
    return host
  }

  function read () {
    var s = store()
    var r = null
    try { r = JSON.parse(s && s.getItem(KEY)) } catch (e) {}
    if (!r || r.v !== 1 || isNaN(Date.parse(r.at))) return null
    if (new Date().getTime() - Date.parse(r.at) > DAYS * 864e5) return null
    return r
  }

  function hasSource (r) {
    return !!(r && (r.referrer || r.gclid || r.msclkid || (r.utm && r.utm.source)))
  }

  /* First visit wins, except that a visit from an ad or a tagged link replaces
     a record that only says "came direct". */
  function capture () {
    if (!/(^|\.)testcandidates\.com$/.test(root.location.hostname)) return null
    if (objected()) return null
    var c = consent()
    if (needsConsent() && !c.analytics) return null
    var s = store()
    if (!s) return null
    var q = root.location.search || ''
    var r = { v: 1, at: new Date().toISOString(), landing: (root.location.pathname || '/').slice(0, 300), referrer: referrerHost(root.document), utm: {} }
    for (var i = 0; i < UTM.length; i++) {
      var v = param(q, 'utm_' + UTM[i])
      if (v) r.utm[UTM[i]] = v.slice(0, 150)
    }
    var ids = ['gclid', 'msclkid']
    for (var j = 0; j < ids.length; j++) {
      var id = param(q, ids[j])
      if (id) r[ids[j]] = c.advertising ? id.slice(0, 255) : true
    }
    var existing = read()
    if (existing && (hasSource(existing) || !hasSource(r))) return existing
    try { s.setItem(KEY, JSON.stringify(r)) } catch (e) { return null }
    return r
  }

  /* What the sign-up sends: the stored record, or failing that what this page
     itself can see (nothing is stored for that). */
  function forSignup () {
    var r = read()
    if (!r && /(^|\.)testcandidates\.com$/.test(root.location.hostname) && !objected()) {
      r = { v: 1, at: new Date().toISOString(), landing: (root.location.pathname || '/').slice(0, 300), referrer: referrerHost(root.document), utm: {} }
      for (var i = 0; i < UTM.length; i++) {
        var v = param(root.location.search || '', 'utm_' + UTM[i])
        if (v) r.utm[UTM[i]] = v.slice(0, 150)
      }
      if (param(root.location.search || '', 'gclid')) r.gclid = true
      if (param(root.location.search || '', 'msclkid')) r.msclkid = true
    }
    if (!r) return null
    var gclid = typeof r.gclid === 'string' ? r.gclid : (adClick() || r.gclid || false)
    return { at: r.at, landing: r.landing, referrer: r.referrer || '', utm: r.utm || {}, gclid: gclid, msclkid: r.msclkid || false }
  }

  /* The Google Ads click id from Google's own conversion linker cookie
     (_gcl_aw = GCL.<time>.<gclid>). Google writes it only while ad storage is
     granted, so it follows the Consent Mode region defaults; we skip it when
     the visitor objected or chose no advertising. The admin turns verified
     sign-ups and first payments with this id into Google Ads conversions. */
  function adClick () {
    if (objected() || consent().advertisingRefused) return ''
    var m = /(?:^|;\s*)_gcl_aw=([^;]+)/.exec(root.document.cookie || '')
    var parts = m ? m[1].split('.') : []
    var id = parts.length >= 3 ? parts.slice(2).join('.') : ''
    return /^[A-Za-z0-9_-]{8,255}$/.test(id) ? id : ''
  }

  var api = { capture: capture, read: read, forSignup: forSignup, KEY: KEY }
  root.TCSignupSource = api
  try { capture() } catch (e) {}
  if (typeof module !== 'undefined' && module.exports) module.exports = api
})(typeof window !== 'undefined' ? window : this)
